// extracted by mini-css-extract-plugin
export default {"approve":"Approval_approve__HybZ-"};